import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS, STALE_TIME } from '@/libs/constants'
import { orgApi } from '@/services/api'

export function useOrgProfile(orgID: string, enabled = true) {
  return useQuery({
    queryKey: QUERY_KEYS.org.profile(orgID),
    queryFn: () => orgApi.getProfile(orgID),
    enabled: enabled && !!orgID,
    staleTime: STALE_TIME['24Hours'],
  })
}
